import { Close, ReportGmailerrorredOutlined } from '@mui/icons-material'
import { Box, Button, Dialog, DialogContent, IconButton, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { backendClient } from '../../../interactors/clients/client'
import { CustomEditor } from '../../Association/CustomEditor'
import { colors } from '../../theme'
import { addPrimaryFabSx, addSecondaryFabSx } from '../../common/addPrimaryCtaSx'

interface Props {
  animalName: string
  customerName: string
  animalId: string
  adopterId: string
  buttonLabel?: string
}

export const ReviveAdopterPopUp: React.FC<Props> = ({
  animalId,
  adopterId,
  animalName,
  customerName,
  buttonLabel = "Relancer l'adoptant",
}) => {
  const [editorContent, setEditorContent] = useState<string>('')
  const [subject, setSubject] = useState<string>(`${customerName} - Votre adoption de ${animalName}`)

  const [open, setOpen] = useState<boolean>(false)
  const close = () => setOpen(false)

  useEffect(() => {
    const fetchEmail = async () => {
      if (!animalId || !adopterId) return
      try {
        const email = await backendClient.post('adopters/generate-email', {
          animalId,
          adopterId,
        })
        setEditorContent(email.data)
      } catch (error) {
        console.error('Error fetching email:', error)
      }
    }

    fetchEmail()
  }, [])

  const sendEmailAndSubmit = async () => {
    try {
      await backendClient.post('adopters/send-email', {
        adopterId,
        email: editorContent,
        subject: subject,
      })
      close()
    } catch (error) {
      console.error('Error sending email:', error)
    }
  }
  return (
    <>
      <Button
        variant="text"
        onClick={() => setOpen(true)}
        sx={{
          ...addSecondaryFabSx,
          fontSize: { xs: '14px', sm: '15px' },
          minHeight: 36,
          height: 36,
          px: { xs: 1.5, sm: 1.75 },
          width: { xs: '100%', sm: 'auto' },
          whiteSpace: 'nowrap',
          borderColor: 'transparent',
          backgroundColor: 'transparent',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: 'rgba(232, 242, 251, 0.72)',
            borderColor: 'transparent',
          },
        }}
      >
        {buttonLabel}
      </Button>
      <Dialog open={open} onClose={close} fullWidth maxWidth="md">
        <DialogContent>
          <IconButton sx={{ position: 'absolute', top: 10, right: 10 }} onClick={close}>
            <Close />
          </IconButton>

          <Box sx={{ textAlign: 'center', padding: '1.5rem' }}>
            <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', mb: 1, textAlign: 'left' }}>
              <ReportGmailerrorredOutlined sx={{ color: colors.cello, fontSize: '3rem' }} />
              <Box sx={{ display: 'flex', flexDirection: 'column', ml: 2 }}>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 'bold',
                    color: colors.cello,
                  }}
                >
                  Relance de l&apos;adoptant
                </Typography>
              </Box>
            </Box>
            <TextField
              fullWidth
              label="Sujet de l'email"
              type="email"
              value={subject}
              size="small"
              onChange={(e) => setSubject(e.target.value)}
              sx={{ my: 1 }}
            />
            <CustomEditor
              editorContent={editorContent}
              setEditorContent={setEditorContent}
              logoUrl=""
              signatureUrl=""
            />

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => sendEmailAndSubmit()}
                sx={{
                  ...addPrimaryFabSx,
                  mt: 1,
                }}
              >
                Envoyer l&apos;email pour relancer l&apos;adoptant
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  )
}
